import { render, staticRenderFns } from "./MainToolbar.vue?vue&type=template&id=b9bc077a&scoped=true&"
import script from "./MainToolbar.vue?vue&type=script&lang=ts&"
export * from "./MainToolbar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bc077a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib'
import { VToolbar } from 'vuetify/lib'
import { VToolbarTitle } from 'vuetify/lib'
installComponents(component, {VSpacer,VToolbar,VToolbarTitle})
